import { render, staticRenderFns } from "./BadgePriority.vue?vue&type=template&id=6a893996&"
import script from "./BadgePriority.vue?vue&type=script&lang=ts&"
export * from "./BadgePriority.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports